import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './index.css'
import { createPinia } from 'pinia'

import { onAuthStateChanged } from 'firebase/auth'
import { auth } from '@/firebase' // <-- usa il tuo export auth

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'

library.add(fas, fab, far)

let app: ReturnType<typeof createApp> | null = null

onAuthStateChanged(auth, () => {
  if (app) return

  app = createApp(App)
  app.use(createPinia())
  app.use(router)
  app.component('font-awesome-icon', FontAwesomeIcon)
  app.mount('#app')
})
